import moment from 'moment';

export const DATE_RANGE_NEXT_30 = 30;
export const DATE_RANGE_NEXT_60 = 60;
export const DATE_RANGE_NEXT_90 = 90;
export const DATE_RANGE_CUSTOM = 0;

export const MIN_DATE = moment().endOf('day');

export default [
  { value: DATE_RANGE_NEXT_30, label: 'Next 30 days' },
  { value: DATE_RANGE_NEXT_60, label: 'Next 60 days' },
  { value: DATE_RANGE_NEXT_90, label: 'Next 90 days' },
  { value: DATE_RANGE_CUSTOM, label: 'Custom' }
];
